<template>
  <div>
    <span class="column-action-button bg-light d-flex justify-content-center align-items-center border" :id="`movements-${id}-${_uid}`">
      <i class="mdi mdi-timeline-check-outline"></i>
    </span>
    <b-popover
      :target="`movements-${id}-${_uid}`"
      triggers="hover focus"
      placement="right"
      boundary="viewport"
      :delay="{ show: 800, hide: 100 }"
      @show="loadMovements"
      custom-class="datatables-comments-popover"
    >
      <template #title>
        <div class="px-2 d-flex align-items-center">
          <i class="mdi mdi-timeline-check-outline mr-3" style="font-size: 1.5rem"></i>
          <span>Movmientos</span>
        </div>
      </template>
      <template v-if="!isLoading">
        <div class="scroll">
          <a-timeline
            class="p-4"
            mode="alternate"
            v-if="movements.items.length"
          >
            <a-timeline-item
              v-for="(m, index) of movements.items"
              :key="index"
              :color="m.color || 'gray'"
            >
              <a-icon
                v-if="m.icon"
                slot="dot"
                :type="m.icon"
                style="font-size: 22px;"
              />
              <div class="datos d-flex flex-column mx-2">
                <span class="font-weight-bold" :style="{color: titleColor[m.color]}">{{ m.title }}</span>
                <span>
                  <b-avatar
                    v-if="!m.noavatar"
                    class="my-2"
                    size="2.6em"
                    :text="m.userInitials"
                    :src="m.avatar"
                    v-b-popover.hover="popoverConfig(m, index)"
                    :style="{'background-color': titleColor[m.color]}"
                  ></b-avatar>
                </span>
                <span
                  v-if="m.destination.area"
                >
                  <div class="mt-2"><strong>Área:</strong> {{m.destination.area.name}}</div>
                </span>
                <span
                  v-if="m.destination.subarea"
                >
                  <div class="mt-2"><strong>Subárea:</strong> {{m.destination.subarea.name}}</div>
                </span>
                <span
                  v-if="m.destination.user"
                >
                  <div class="mt-2"><strong>Área:</strong> {{m.destination.user.area.name}}</div>
                  <div><strong>Subárea:</strong> {{m.destination.user.subarea.name}}</div>
                </span>
                <span
                  v-if="m.area && m.subarea"
                >
                  {{ m.area.name }} - {{ m.subarea.name }}
                </span>
                <span
                  v-if="m.createdAt"
                  class="font-weight-light"
                >
                  {{ m.createdAt }}
                </span>
              </div>
            </a-timeline-item>
          </a-timeline>
          <template v-else>
            <LmSvgIcon
              style="height: 175px"
              wrapperClass="d-flex justify-content-center align-items-center flex-column"
              width="6em"
              icon="LmNoDataIcon"
              text="No hay movimientos"
            />
          </template>
        </div>
      </template>
      <!-- loading state -->
      <template v-else>
        <div class="scroll">
          <a-timeline
            class="p-4"
            mode="alternate"
          >
            <a-timeline-item
              v-for="(item, index) of 5"
              :key="index"
              color="gray"
            >
              <div class="d-flex flex-column" :class="index % 2 ? 'align-items-end' : 'align-items-start'" style="gap: .2rem">
                <b-skeleton width="60%"></b-skeleton>
                <b-skeleton type="avatar"></b-skeleton>
                <b-skeleton width="100%"></b-skeleton>
              </div>
            </a-timeline-item>
          </a-timeline>
        </div>
      </template>
    </b-popover>
  </div>
</template>

<script>
// Utils
import commonsApi from '@/api/commons'

export default {
  props: {
    id: {
      type: String,
      required: true
    },
    source: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      isLoading: false,
      movements: {
        items: []
      },
      titleColor: {
        red: '#f5222d',
        gray: '#6c757d',
        green: '#52c41a',
        blue: '#1890ff'
      }
    }
  },
  methods: {
    async loadMovements () {
      try {
        this.isLoading = true
        if (this.movements.items.length) return
        const res = await commonsApi.axiosGetWrapper(`/${this.source}/movements/${this.id}`)
        const movements = res.data?.rows.map(r => {
          let createdBy
          if (r.origin?.user) {
            createdBy = r.origin.user.firstname + ' ' + r.origin.user.lastname
          }
          return {
            userInitials: r.created_by?.userInitials,
            createdAt: r.created_at,
            createdBy: createdBy,
            title: r.movement_code,
            ...r
          }
        })
        this.movements.items = movements
      } catch (error) {
        console.log(error)
      } finally {
        this.isLoading = false
      }
    },
    popoverConfig (m, index) {
      return {
        content: m.createdBy,
        placement: index % 2 === 0 ? 'right' : 'left',
        boundary: 'viewport'
      }
    }
  }
}
</script>
